<!-- 投诉管理 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('联系人名称')">
              <j-input :placeholder="$t('请输入联系人名称')" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('状态')">
              <a-select v-model="queryParam.complaintsState" :placeholder="$t('请选择状态')">
                <a-select-option :value="0">{{ $t('未处理') }}</a-select-option>
                <a-select-option :value="1">{{ $t('已处理') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('留言类型')">
              <a-select v-model="queryParam.complaintsType" :placeholder="$t('请选择留言类型')">
                <a-select-option value="0">{{ $t('咨询') }}</a-select-option>
                <a-select-option value="1">{{ $t('建议') }}</a-select-option>
                <a-select-option value="2">{{ $t('投诉') }}</a-select-option>
                <a-select-option value="3">{{ $t('其他') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="complaintsState" slot-scope="text,record">
          <a-tag color="#108ee9" v-if="record.complaintsState==0">{{ $t('处理中') }}</a-tag>
          <a-tag color="#87d068" v-if="record.complaintsState==1">{{ $t('等待评价') }}</a-tag>
          <a-tag color="#f50" v-if="record.complaintsState==2">{{ $t('结束') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.complaintsState == 0">
            <a @click="handle(record)">{{ $t('处理') }}</a>
            <a-divider type="vertical" />
          </template>
          <template v-if="record.complaintsState == 2">
            <a @click="handleEvaluate(record)">{{ $t('查看评价') }}</a>
            <a-divider type="vertical" />
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <handleModal ref="handleForm" @ok="modalFormOk"></handleModal>
    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
    <rateModal ref="rateForm"></rateModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import handleModal from './handleModal'
  import Modal from './modal'
  import rateModal from './rateModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      handleModal,
      Modal,
      rateModal,
      JInput
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/oa/userComplaints/list",
          delete: "/jeecg-charge/oa/userComplaints/delete",
          deleteBatch: "/jeecg-charge/oa/userComplaints/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },

          {
            title: this.$t('留言类型'),
            align:"center",
            dataIndex: 'complaintsType',
            customRender:(t)=>{
              const labels = [this.$t('咨询'), this.$t('建议'), this.$t('投诉'), this.$t('其他')]
              if(t!=null){
                return labels[t]
              }else{
                return this.$t('其他')
              }
            },
            width:100,
            ellipsis: true,
          },
          {
            title: this.$t('联系人名称'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('联系人电话'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('精确地址'),
            align:"center",
            dataIndex: 'userAddress',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('情况描述'),
            align:"center",
            dataIndex: 'complaintsDetail',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('状态'),
            align:"center",
            dataIndex: 'complaintsState',
            scopedSlots: { customRender: 'complaintsState' },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('处理人'),
            align:"center",
            dataIndex: 'complaintsProcessors',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('处理时间'),
            align:"center",
            dataIndex: 'complaintsTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      // 处理
      handle(row){
        this.$nextTick(()=>{
          this.$refs.handleForm.init(row);
        });
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row);
        });
      },
      // 查看评价
      handleEvaluate(row){
        this.$nextTick(()=>{
          this.$refs.rateForm.init(row);
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>